<template>
  <component
    v-if="type !== 'hidden'"
    v-bind="$options.components[name] ? $attrs : { ...$attrs, type }"
    :error="error"
    :is="component ?? ($options.components[name] ? name : 'TextField')"
  >
    <template v-for="(value, key) in $slots" v-slot:[key]>
      <slot :name="key" />
    </template>
  </component>
</template>

<script>
import CheckboxField from 'Web/Form/Fields/CheckboxField.vue';
import CheckboxesField from 'Web/Form/Fields/CheckboxesField.vue';
import CouponField from 'Web/Form/Fields/CouponField.vue';
import DateField from 'Web/Form/Fields/DateField.vue';
import DatetimeField from 'Web/Form/Fields/DatetimeField.vue';
import RadioField from 'Web/Form/Fields/RadioField.vue';
import RelationField from 'Web/Form/Fields/RelationField.vue';
import SelectField from 'Web/Form/Fields/SelectField.vue';
import StructureField from 'Web/Form/Fields/StructureField.vue';
import TextField from 'Web/Form/Fields/TextField.vue';
import TextareaField from 'Web/Form/Fields/TextareaField.vue';
import TimeField from 'Web/Form/Fields/TimeField.vue';
import { capitalize, computed } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    CheckboxField,
    CheckboxesField,
    CouponField,
    DateField,
    DatetimeField,
    RadioField,
    RelationField,
    SelectField,
    StructureField,
    TextField,
    TextareaField,
    TimeField,
  },
  props: {
    component: {
      type: Object,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  setup(props) {
    const name = computed(() => capitalize(props.type) + 'Field');

    return {
      name,
    }
  }
}
</script>
